var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebDropdownExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 11.5,
    viewBox: "0 0 23 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,11.5,11.5,0,23,11.5Z",
    fill: "rgba(0,0,0,0.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDropdownExpandIcon);
export default __webpack_public_path__ + "static/media/Web_Dropdown_Expand_Icon.d288c1da8ae4f8a8b30a637cf5f4cf07.svg";
export { ForwardRef as ReactComponent };